import { atomWithReset } from 'jotai/utils';

import { ModificationMode, UserActionMenuType, HandleModificationProps } from 'src/types/report';

export const reviewModificationAtom = atomWithReset<
  (HandleModificationProps<UserActionMenuType.REVIEW> & { mode: ModificationMode }) | null
>(null);
